<template>
  <div class="w-full max-w-screen-sm px-4 py-2 rounded bg-white m-2 flex">
    <div class="w-1/4 items-center justify-center flex text-xl font-mono">
      <h1>{{ serviceno }}</h1>
    </div>

    <div class="flex flex-col">
      <p class="font-semibold self-start">{{ time }}</p>

      <div class="flex items-center">
        <p>Fill |</p>

        <i
          v-for="icon in seatsIcon"
          v-bind:class="['fa', 'fa-fw', icon]"
          aria-hidden="true"
          :key="icon.id"
        ></i>

        <div class="px-2">
          <i class="fa fa-fw fa-bus  inline-block" aria-hidden="true"></i>
          <p class="inline-block">| {{ vehicle[type] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Entry",
  props: {
    serviceno: String,
    time: String,
    load: String,
    type: String
  },
  data: function() {
    return {
      vehicle: {
        SD: "Single",
        DD: "Double",
        BD: "Bendy"
      },
      seats: {
        SEA: "Seats Available",
        SDA: "Standing Available",
        LSD: "Limited Standing"
      },
      seatsIcon: {
        SEA: ["fa-user-o", "fa-user-o", "fa-user"],
        SDA: ["fa-user-o", "fa-user", "fa-user"],
        LSD: ["fa-user", "fa-user", "fa-user"]
      }
    };
  },
  methods: {}
};
</script>

<style scoped></style>
